import { render, staticRenderFns } from "./_edit_lesson_form.vue?vue&type=template&id=6825e697"
import script from "./_edit_lesson_form.vue?vue&type=script&lang=js"
export * from "./_edit_lesson_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports